import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agile-understanding',
  templateUrl: './agile-understanding.component.html',
  styleUrls: ['./agile-understanding.component.sass']
})
export class AgileUnderstandingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
